import { render, staticRenderFns } from "./mouthSelect.vue?vue&type=template&id=1dec65c9&scoped=true&"
import script from "./mouthSelect.vue?vue&type=script&lang=js&"
export * from "./mouthSelect.vue?vue&type=script&lang=js&"
import style0 from "./mouthSelect.vue?vue&type=style&index=0&lang=css&"
import style1 from "./mouthSelect.vue?vue&type=style&index=1&id=1dec65c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec65c9",
  null
  
)

export default component.exports